export default {
  init() {
    wrapHeadingsForGradient()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}

const wrapHeadingsForGradient = () => {
  const headings = document.querySelectorAll('.wp-block-heading')

  Array.from(headings).map(heading => {
    const text = heading.innerHTML
    heading.innerHTML = `<span>${text}</span>`
  })
}
